export const categories = [
  {
    id: "classic",
    name: "经典电影",
    tag: "经典电影",
    description: "被时间反复验证的作品，值得一看再看。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20collage%20of%20classic%20film%20reels%20and%20old%20cinema%20tickets%20on%20cream%20paper%2C%20sepia%20and%20peach%20tones%2C%20nostalgic%20editorial%20mood&width=600&height=400&seq=cat-classic&orientation=landscape",
  },
  {
    id: "90s",
    name: "90年代电影",
    tag: "90年代",
    description: "黄金十年的城市与青春，尽在霓虹光影之中。",
    cover:
      "https://readdy.ai/api/search-image?query=nostalgic%201990s%20city%20street%20with%20neon%20signs%20at%20dusk%2C%20warm%20amber%20and%20peach%20tones%2C%20soft%20grain%2C%20editorial%20mood&width=600&height=400&seq=cat-90s&orientation=landscape",
  },
  {
    id: "asia",
    name: "亚洲电影",
    tag: "亚洲电影",
    description: "跨越地域与语言，映照整个时代的情感图谱。",
    cover:
      "https://readdy.ai/api/search-image?query=artistic%20map%20like%20collage%20of%20Asian%20city%20skylines%20at%20warm%20dusk%2C%20peach%20and%20cream%20tones%2C%20editorial%20mood&width=600&height=400&seq=cat-asia&orientation=landscape",
  },
  {
    id: "romance",
    name: "爱情片",
    tag: "爱情",
    description: "关于相遇与错过，那些甜中带涩的故事。",
    cover:
      "https://readdy.ai/api/search-image?query=romantic%20pair%20of%20silhouettes%20on%20a%20ferry%20at%20sunset%2C%20warm%20rose%20and%20peach%20tones%2C%20soft%20bokeh%2C%20editorial%20mood&width=600&height=400&seq=cat-romance&orientation=landscape",
  },
  {
    id: "drama",
    name: "剧情片",
    tag: "剧情",
    description: "生活的重量藏在细节里，安静却汹涌。",
    cover:
      "https://readdy.ai/api/search-image?query=quiet%20interior%20scene%20with%20a%20window%20and%20warm%20lamp%2C%20cream%20and%20amber%20tones%2C%20introspective%20editorial%20mood&width=600&height=400&seq=cat-drama&orientation=landscape",
  },
  {
    id: "hk",
    name: "香港电影",
    tag: "香港电影",
    description: "霓虹、雨夜与渡轮，构成一代人的共同记忆。",
    cover:
      "https://readdy.ai/api/search-image?query=Hong%20Kong%20harbour%20skyline%20at%20night%20with%20warm%20neon%20reflections%2C%20amber%20and%20rose%20tones%2C%20cinematic%20editorial%20mood&width=600&height=400&seq=cat-hk&orientation=landscape",
  },
];